import { render, staticRenderFns } from "./WorkshopBanner.vue?vue&type=template&id=78d6e513&scoped=true&"
import script from "./WorkshopBanner.vue?vue&type=script&lang=js&"
export * from "./WorkshopBanner.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopBanner.vue?vue&type=style&index=0&id=78d6e513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d6e513",
  null
  
)

export default component.exports